import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 初始化蓝牙模块
export function openBluetoothAdapter(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(
    APINames.Native.OPEN_BLUETOOTH_ADAPTER,
    option
  );
}
